<template>
  <div class="max" v-if="showPageInfo">
    <div class="interface_box">
      <div class="top">
        <div class="title">{{ interface.name }}</div>
        <div class="time">
          <i class="el-icon-timer"/>
          {{ interface.updateDate }}
        </div>
      </div>
      <div class="body" id="description">
        <p class="info_item">
          请求方式：
          <span style="color: #17B26A" v-if="interface.method === 1">GET</span>
          <span style="color: #EF6820" v-else>POST</span>
        </p>
        <p class="info_item">请求地址： {{ interface.address }}</p>
        <p class="info_item sub_title">功能说明:</p>
        <div v-html="interface.apiDesc"></div>
      </div>
      <div class="body" id="requestBox">
        <div class="title">请求参数</div>
        <el-table :data="interface.requestParams" row-key="id" default-expand-all stripe
                  border :tree-props="{children: 'children', hasChildren: true}">
          <el-table-column prop="fieldName" label="接口字段" width="260px"></el-table-column>
          <el-table-column prop="fieldNameCn" label="字段名称" width="180"></el-table-column>
          <el-table-column prop="fieldType" label="类型" width="200"></el-table-column>
          <el-table-column prop="notNull" label="必传" width="100">
            <template slot-scope="scope">
              {{ scope.row.notNull ? 'true' : 'false' }}
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="备注">
            <template slot-scope="scope">
              <div v-html="scope.row.desc"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="body" id="responseBox">
        <div class="title">响应参数</div>
        <el-table :data="interface.responseBody" row-key="id" default-expand-all stripe
                  border :tree-props="{children: 'children', hasChildren: true}">
          <el-table-column prop="fieldName" label="接口字段" width="260px"></el-table-column>
          <el-table-column prop="fieldNameCn" label="字段名称" width="180"></el-table-column>
          <el-table-column prop="fieldType" label="类型" width="200"></el-table-column>
          <el-table-column prop="desc" label="备注">
            <template slot-scope="scope">
              <div v-html="scope.row.desc"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="body" id="requestExample">
        <div class="title">请求示例</div>
        <MyJsonViewer :value="interface.requestExample" :show-array-index="false"
                      v-if="interface.requestExample" preview-mode/>
        <div v-else class="json_none">
          无
        </div>
      </div>
      <div class="body" id="responseExample">
        <div class="title">响应示例</div>
        <MyJsonViewer :value="interface.responseExample" :show-array-index="false"
                      v-if="interface.responseExample" preview-mode/>
        <div v-else class="json_none">
          无
        </div>
      </div>
    </div>
    <div class="anchor_point_box">
      <div class="point_box">
        <div class="point_item" :class="currentPoint === item.value ? 'active' : ''" @click="toPoint(item.value)"
             v-for="item in pointList" :key="item.value">
          <i class="iconfont icon-maodian" v-if="currentPoint === item.value"/>
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyJsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'
import {throttle} from 'lodash'

export default {
  name: 'interface.vue',
  components: {
    MyJsonViewer
  },
  computed: {
    showPageInfo () {
      return this.$route.path.includes('openApi') && localStorage.getItem('openApiPartnerInfo')
    }
  },
  data () {
    return {
      interface: {},
      currentPoint: 'description',
      pointList: [{
        name: '功能说明', value: 'description'
      }, {
        name: '请求参数', value: 'requestBox'
      }, {
        name: '请求响应', value: 'responseBox'
      }, {
        name: '请求示例', value: 'requestExample'
      }, {
        name: '响应示例', value: 'responseExample'
      }],
      menu: []
    }
  },
  mounted () {
    this.toPoint('description')
    window.addEventListener('scroll', throttle(this.handleScroll, 200))
  },
  watch: {
    '$route.query': {
      handler (val) {
        if (this.$route.path.includes('interface')) {
          this.getInterFace()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async searchOpenApiInfos () {
      let jsonStr = localStorage.getItem('openApiPartnerInfo')
      if (jsonStr) {
        let info = JSON.parse(jsonStr)
        const {data: result} = await this.$http.get('/mini/searchOpenApiInfos', {headers: {accessToken: info.token}})
        if (result.code !== 200) return
        this.menu = result.data
        this.formatJSON()
        await this.$store.commit('setMenuList', result.data)
        this.interface = this.$store.getters.findById(this.$route.query.id)
      }
    },
    formatJSON () {
      this.menu.forEach(item => {
        item.openApiList.forEach(i => {
          if (i.type === 1) {
            this.$set(i, 'requestParams', this.formatArr(i.requestParams))
            this.$set(i, 'responseBody', this.formatArr(i.responseBody))
            this.$set(i, 'requestExample', this.formatObj(i.requestExample))
            this.$set(i, 'responseExample', this.formatObj(i.responseExample))
          }
        })
      })
    },
    formatObj (str) {
      if (!str) return {}
      try {
        return JSON.parse(str)
      } catch (e) {
        return {}
      }
    },
    formatArr (str) {
      if (!str) return []
      try {
        return JSON.parse(str)
      } catch (e) {
        return []
      }
    },
    async getInterFace () {
      this.interface = this.$store.getters.findById(this.$route.query.id)
      if (!this.interface || !this.interface.id) {
        await this.searchOpenApiInfos()
      }
    },
    toPoint (id) {
      this.$nextTick(() => {
        let content = this.$el.querySelector(`#${id}`)
        if (!content) return
        content.scrollIntoView({block: 'center', behavior: 'instant'})
        this.currentPoint = id
      })
    },
    handleScroll () {
      this.$nextTick(() => {
        const contents = document.querySelectorAll('.body')
        if (!contents) return
        const offsetTopArr = []
        contents.forEach(item => {
          offsetTopArr.push(item.offsetTop)
        })

        const scrollTop = window.scrollY
        offsetTopArr.forEach((item, index) => {
          if (scrollTop === 0) {
            this.currentPoint = 'description'
          }
          if (scrollTop >= item - 450) {
            this.currentPoint = contents[index].id
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.max {
  padding: 20px;
  background-color: #fff;
  font-family: "苹方", serif;
  user-select: text !important;
  display: flex;
}

.interface_box {
  width: 85%;
  font-size: 14px;

  & /deep/ p {
    margin-bottom: 12px !important;
  }

  & /deep/ h1,
  & /deep/ h2,
  & /deep/ h3,
  & /deep/ h4,
  & /deep/ h5,
  & /deep/ h6,
  & /deep/ b,
  & /deep/ strong {
    margin-bottom: 10px !important;
    font-weight: bolder !important;
  }

  .top {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 25px;

    .title {
      font-size: 28px;
      font-weight: bolder;
    }

    .time {
      margin-top: 15px;
      color: #d6c0d6;
    }
  }

  .body {
    margin-top: 35px;

    .info_item {
      &.sub_title {
        font-weight: bolder;
      }
    }

    .title {
      font-size: 20px;
      font-weight: bolder;
      margin-bottom: 20px;
    }

    .json_none {
      background-color: #f2f2f2;
      height: 64px;
      border-radius: 4px;
      color: #42b983;
      padding-left: 15px;
      line-height: 64px;
    }

    & /deep/ .jv-code {
      padding: 20px;
      background-color: #f2f2f2;
      border-radius: 5px;
    }

    & /deep/ .jv-node {
      padding: 5px;
    }

    & /deep/ .jv-container.jv-light .jv-item.jv-string {
      line-height: 20px;
    }

    & /deep/ .el-table th {
      background-color: #f4f4f4;
      color: #000;
    }

    & /deep/ .el-icon-arrow-right:before {
      font-weight: bolder;
      color: #000;
    }

    .el-table /deep/ p {
      margin-bottom: 0 !important;
    }
  }

}

.anchor_point_box {
  width: 15%;
  position: fixed;
  right: -20px;

  .point_box {
    padding-left: 20px;
    margin-left: 20px;
    height: 200px;
    position: relative;

    .point_item {
      font-size: 14px;
      margin-bottom: 25px;
      cursor: pointer;
      user-select: none;

      &.active {
        color: #3d9eff;
      }
    }

    .icon-maodian {
      position: absolute;
      left: -6px;
    }

    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      background-color: #e9e9e9;
      top: 0;
      left: 0;
      height: 170px;
      width: 4px;
      border-radius: 4px;
    }
  }
}

@media screen and (max-width: 1290px) {
  .anchor_point_box {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/components/interface.vue